import keyBy from "lodash/keyBy";
import orderBy from "lodash/orderBy";
import pick from "lodash/pick";
import { BookingsTable } from "PFApp/components/bookings_table";
import { Accordion } from "PFComponents/accordion";
import { Activity, Booking } from "PFTypes";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./selected_bookings.module.scss";

const PAGE_SIZE = 10;

type SelectedBookingsProps = {
  bookings: Booking[];
  notAllowedBookings: Booking[];
  activities: Activity[];
  notAllowedActivities: Activity[];
};

export const SelectedBookings = ({
  bookings,
  notAllowedBookings,
  activities,
  notAllowedActivities
}: SelectedBookingsProps) => {
  const { t } = useTranslation("bookingModule");

  const sortedBookings = useMemo(() => {
    const activitiesById = keyBy([...activities, ...notAllowedActivities], "id");
    const bookingsWithActivityData = [
      ...bookings,
      ...notAllowedBookings.map((booking) => ({
        ...booking,
        disabled: true,
        message: t("bookings.reassign.sidePanel.auditRolesCantGetReassigned")
      }))
    ].map((booking) => ({
      ...booking,
      activity: booking.activity_id
        ? pick(activitiesById[booking.activity_id], "id", "name", "template_id")
        : undefined
    }));

    return orderBy(
      bookingsWithActivityData,
      ["activity.name", "activity.id", "title", "start_date"],
      ["asc", "asc", "asc", "asc"]
    );
  }, [bookings, notAllowedBookings, activities, notAllowedActivities, t]);

  return (
    <Accordion
      header={t("bookings.reassign.sidePanel.selectedBookings")}
      defaultState="closed"
      headerVariant="bodyBold"
      iconSet="chevron"
      classes={{ root: css.root }}
    >
      <BookingsTable
        bookings={sortedBookings}
        isDense
        simplePaginationEnabled
        simplePaginationPageSize={PAGE_SIZE}
      />
    </Accordion>
  );
};
